'use client';

import { useState } from 'react';

import { Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';

import { IntroAssignGradeAuto } from '../components/intro-assign-grade-auto';
import { StartAssignGradeAuto } from '../components/start-assign-grade-auto';
import { AssignGradeAutoFunctions } from '../components/assign-grade-auto-functions';

export const AssignGradeAutoView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Container>
      <IntroAssignGradeAuto setOpenDemoForm={(value) => setOpenDemo(value)} />
      <CustomerElearning />
      <AssignGradeAutoFunctions />
      <StartAssignGradeAuto setOpenDemoForm={(value) => setOpenDemo(value)} />{' '}
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Container>
  );
};
